import { client } from "../../../../Infrastructure/agent";

export const WellPerformanceService = {
  getuniqueWellsData: (producing) =>
    client.post("/WellPerformance/GetUniqueWellsData", { producing }),
  getPlotData: (uniqueId) =>
    client.post("/WellPerformance/GetPlotData", { uniqueId }),
};

